import { render } from "./TableDemo.vue?vue&type=template&id=717b79f0&scoped=true"
import script from "./TableDemo.vue?vue&type=script&lang=js"
export * from "./TableDemo.vue?vue&type=script&lang=js"

import "./TableDemo.vue?vue&type=style&index=0&id=717b79f0&scoped=true&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/eAzC_LUi/0/econsultingsistemas/certificadorweb/certificador-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717b79f0"]])

export default __exports__